(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbQWrapper', fbQWrapperDirective);

    const defaultTemplate = "<div class='row up-fields up-fields-inline'>" +
        "<div class='fbc-question small-12 medium-7 columns' ng-bind-html='vm.element.options.question|lineBreakReplacement'></div>" +
        "<div class='ynq-choice small-12 medium-5 columns' >" +
        "<transclude>" +
        "<div ng-show='vm.showTextBox()'><textarea type='text' ng-model='vm.model.others' placeholder='Please provide details' ng-blur='vm.onBlur($event)'></textarea></div>" +
        "</div>" +
        '</div>';

    function fbQWrapperDirective($templateCache, lodash) {
        return {
            restrict: 'EA',
            // transclude: true,
            scope: {
                element: '=',
                model: '=',
                template: '=?'
            },
            // template: function(elem, attr) {
            //     console.log(arguments);
            //     var templateUrl = lodash.get(attr, 'template', '');
            //     if (lodash.isEmpty(templateUrl)) {
            //         return defaultTemplate;
            //     }
            //     var template = $templateCache.get(templateUrl);
            //     if (lodash.isEmpty(template)) {
            //         return defaultTemplate;
            //     }
            //     return template;
            // },
            controller: fbQWrapperDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function fbQWrapperDirectiveCtrl($scope, lodash, $compile, $templateCache, $element) {
        var vm = this;
        this.$onInit = function() {
            vm.onBlur = onBlur;
            vm.showTextBox = showTextbox;

            vm.textSetting = vm.element.options.settings.showText || null;

            var selectedTemplate = defaultTemplate;
            if (!lodash.isEmpty(vm.template)) {
                var temp = $templateCache.get(vm.template);
                if (!lodash.isEmpty(temp)){
                    selectedTemplate = temp;
                }
            }

            selectedTemplate = selectedTemplate.replace('<transclude>', $element.html());

            $element.html(selectedTemplate);
            var cloneElement = $compile($element.contents())($scope);

            $scope.$on('$destroy', ()=> {
                cloneElement.off();
            });
        }

        function showTextbox() {
            if (vm.model.answer == null) {
                return false;
            }

            var result = false;
            switch (vm.textSetting.operator) {
                case "eq":
                    result = (vm.textSetting.value == lodash.get(vm, 'model.answer', null));
                    break;
                case "notEq":
                    result = (vm.textSetting.value != lodash.get(vm, 'model.answer', null));
                    break;
                case "in":
                    if (['multichoice'].indexOf(vm.element.type) >= 0) {
                        result = false;
                        var ansArr = lodash.get(vm, 'model.answer', []);
                        for (var i in ansArr) {
                            var _ans = ansArr[i];
                            if (vm.textSetting.value.indexOf(_ans) >= 0) {
                                result = true;
                                break;
                            }
                        }

                    } else {
                        result = (vm.textSetting.value.indexOf(parseInt(lodash.get(vm, 'model.answer', -1))) != -1);
                    }
                    break;
            }
            return result;
        }

        function onBlur($event) {
            if (showTextbox() ) {
                if (!lodash.has(vm.model,'others') || lodash.get(vm.model,'others','').length == 0) {
                    angular.element($event.target).parent().addClass('error');
                    angular.element($event.target).parent().find('.error-message').remove();
                    angular.element($event.target).after('<span class="error-message">Additional details are required.</span>');
                } else {
                    angular.element($event.target).parent().removeClass('error');
                    angular.element($event.target).parent().find('.error-message').remove();
                }
            }
        }
    }
})();